import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import NumberFormat from 'react-number-format'
import {
  BENEFICIARY_TRANSFER_KEYS,
  SIDENAV_KEYS,
  ADD_BENEFICIARY,
} from '../../../../utils/translation-constants'
import { NeoOTP, NeoSuccess } from '../../../../components/FormComponents'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import InputError from '../../../../components/InputError/InputError'
import Loading from 'custom/assets/loaders/Loading'
import { AddInternationalBeneficiarySchema } from '../../../../schemas/beneficiary-transfer'
import BeneficiaryTransferService from '../../../../services/beneficiary-transfers.service'
import TermsAndCondition from '../../../../components/TermsAndConditions/TermsAndCondition'
import config from 'custom/config/environment'

import validationConfig from 'custom/config/validation.config.json'
const internationalBeneConfig = validationConfig['addBeneficiary']['international']

const modeOfTransferList = [
  { label: 'SWIFT / BIC', value: 'BIC' },
  { label: 'IFSC', value: 'IFSC' },
  { label: 'Routing', value: 'ROUTE' },
]

export default function AddInternationalBeneficiary() {
  const history = useHistory()
  const [stage, setStage] = useState(0)
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [formValues, setFormValues] = useState({
    benName: '',
    nickName: '',
    accountNumber: '',
    confirmAccountNumber: '',
    bankName: '',
    bankBranch: '',
    maxTransferAmount: '',
    beneEMail: '',
    beneMobileNo: '',
    beneCountry: '',
    bankCountry: '',
    beneAddress: '',
    modeofTransfer: 'SWIFT / BIC',
    code: '',
    bankAddress: '',
    transferAmount: undefined,
  })
  const [countries, setCountries] = useState([])
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [otp, setOtp] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    fetchCountries()
  }, [])

  const fetchCountries = useCallback(async () => {
    const response = await BeneficiaryTransferService.getCountries()
    setCountries(response)
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return <NeoSuccess message={message} linkPath='/beneficiary-transfers' />
      default:
        return renderForm()
    }
  }

  const onVerify = useCallback(async (data) => {
    try {
      if (data.transferAmount < config.MIN_TRANSFER_LIMIT) {
        return
      }
      setLoading(true)
      const mode = modeOfTransferList.filter((ele) => ele.label === data.modeofTransfer)[0]
      setFormValues(data)
      const response = await BeneficiaryTransferService.verifyAddOtherBeneficiary({
        addrline: data.beneAddress,
        bankCode: data.code,
        bankName: data.bankName,
        srcAccount: data.accountNumber,
        beneBrn: data.bankBranch,
        beneCurrency: config.LOCAL_CURRENCY_CODE,
        beneName: data.benName,
        beneType: 'INTERNATIONAL',
        bicCode: data.code,
        city: data.country,
        maxTransferLimit: data.maxTransferAmount,
        shortName: data.nickName,
        sortCode: data.code,
        beneEMail: data.beneEMail,
        beneMobileNo: data.beneMobileNo,
        favorites: 'N',
        terms: 'Y',
        beneCountry: data.beneCountry,
        modeOfTransfer: mode?.value || '',
        bankAddress: data.bankAddress,
        bankCountry: data.bankCountry,
        module: 'Beneficary',
      })

      if (response.status === 200) {
        setOtpEnabled(response.data['otpEnable'])
        setLoading(false)
        setStage(2)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const onConfirm = useCallback(async () => {
    setLoading(true)
    try {
      const mode = modeOfTransferList.filter((ele) => ele.label === formValues.modeofTransfer)[0]
      const response = await BeneficiaryTransferService.addOtherBeneficiary({
        addrline: formValues.beneAddress,
        bankCode: formValues.code,
        bankName: formValues.bankName,
        srcAccount: formValues.accountNumber,
        beneBrn: formValues.bankBranch,
        beneCurrency: config.LOCAL_CURRENCY_CODE,
        beneName: formValues.benName,
        beneType: 'INTERNATIONAL',
        bicCode: formValues.code,
        city: formValues.country,
        maxTransferLimit: formValues.maxTransferAmount,
        shortName: formValues.nickName,
        sortCode: formValues.code,
        beneEMail: formValues.beneEMail,
        beneMobileNo: formValues.beneMobileNo,
        favorites: 'N',
        terms: 'Y',
        beneCountry: formValues.beneCountry,
        modeOfTransfer: mode?.value || '',
        bankAddress: formValues.bankAddress,
        bankCountry: formValues.bankCountry,
        module: 'Beneficary',
        otp: otp || '0000',
      })

      if (response.status === 200) {
        setMessage(response.data.message)
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [formValues, otp])

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>
          {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.ADDINTERNATIONAL)}
        </div>
        <Formik
          initialValues={formValues}
          enableReinitialize
          validationSchema={AddInternationalBeneficiarySchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='1'
                    showAsterisk={internationalBeneConfig['isBeneNameRequired']}
                    value={values.benName}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NAME)}
                    name='benName'
                    onChange={handleChange}
                    minLength={2}
                    maxLength={32}
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError text={errors.benName} touched={touched.benName} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='2'
                    showAsterisk={internationalBeneConfig['isNickNameRequired']}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NICK_NAME)}
                    value={values.nickName}
                    name='nickName'
                    minLength={2}
                    maxLength={20}
                    onChange={handleChange}
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError text={errors.nickName} touched={touched.nickName} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='3'
                    showAsterisk={internationalBeneConfig['isAccountNoRequired']}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.ACCOUNT_NUMBER)}
                    name='accountNumber'
                    type='password'
                    // minLength={5}
                    // maxLength={20}
                    mode='single'
                    onChange={handleChange}
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode > 64 && event.charCode < 91) &&
                        !(event.charCode > 96 && event.charCode < 123) &&
                        event.charCode !== 8 &&
                        event.charCode !== 32 &&
                        !(event.charCode >= 48 && event.charCode <= 57)
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError text={errors.accountNumber} touched={touched.accountNumber} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='4'
                    showAsterisk={internationalBeneConfig['isConfirmAccountNoRequired']}
                    text={t(
                      BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.CONFIRM_ACCOUNT_NUMBER,
                    )}
                    mode='single'
                    onChange={handleChange}
                    name='confirmAccountNumber'
                  />
                  <InputError
                    text={errors.confirmAccountNumber}
                    touched={touched.confirmAccountNumber}
                  />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='5'
                    showAsterisk={internationalBeneConfig['isAddressRequired']}
                    value={values.beneAddress}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_ADDRESS)}
                    name='beneAddress'
                    onChange={handleChange}
                  />
                  <InputError text={errors.beneAddress} touched={touched.beneAddress} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='6'
                    showAsterisk={internationalBeneConfig['isBeneCountryRequired']}
                    mode='select'
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_COUNTRY)}
                    name='beneCountry'
                    onChange={handleChange}
                    keyValue='countryName'
                    list={countries}
                    value={values.beneCountry}
                  />
                  <InputError text={errors.beneCountry} touched={touched.beneCountry} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='7'
                    showAsterisk={internationalBeneConfig['isModeOfTransferRequired']}
                    mode='select'
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.MODE_OF_TRANSFER)}
                    name='modeofTransfer'
                    onChange={handleChange}
                    keyValue='label'
                    list={modeOfTransferList}
                    value={values.modeofTransfer}
                  />
                  <InputError text={errors.modeofTransfer} touched={touched.modeofTransfer} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='8'
                    showAsterisk={internationalBeneConfig['isCodeRequired']}
                    mode='single'
                    name='code'
                    text={
                      values.modeofTransfer === 'SWIFT / BIC'
                        ? 'SWIFT/BIC Code'
                        : values.modeofTransfer === 'IFSC'
                        ? 'IFSC Code'
                        : 'Routing Number'
                    }
                    value={values.code}
                    onChange={handleChange}
                    minLength={8}
                    maxLength={11}
                  />
                  <InputError text={errors.code} touched={touched.code} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='9'
                    showAsterisk={internationalBeneConfig['isBeneBankRequired']}
                    value={values.bankName}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BANK)}
                    name='bankName'
                    onChange={handleChange}
                  />
                  <InputError text={errors.bankName} touched={touched.bankName} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='10'
                    showAsterisk={internationalBeneConfig['isBranchRequired']}
                    value={values.bankBranch}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BRANCH)}
                    name='bankBranch'
                    onChange={handleChange}
                  />
                  <InputError text={errors.bankBranch} touched={touched.bankBranch} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='11'
                    showAsterisk={internationalBeneConfig['isBankAddressRequired']}
                    value={values.bankAddress}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BANK_ADDRESS)}
                    name='bankAddress'
                    onChange={handleChange}
                  />
                  <InputError text={errors.bankAddress} touched={touched.bankAddress} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='12'
                    showAsterisk={internationalBeneConfig['isBankCountryRequired']}
                    mode='select'
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BANK_COUNTRY)}
                    placeholder={'Bank Country'}
                    name='bankCountry'
                    onChange={handleChange}
                    keyValue='countryName'
                    list={countries}
                    value={values.bankCountry}
                  />
                  <InputError text={errors.bankCountry} touched={touched.bankCountry} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='13'
                    showAsterisk={internationalBeneConfig['isEmailRequired']}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_EMAIL)}
                    name='beneEMail'
                    value={values.beneEMail}
                    onChange={handleChange}
                    maxLength='30'
                  />
                  <InputError text={errors.beneEMail} touched={touched.beneEMail} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='14'
                    showAsterisk={internationalBeneConfig['isMobileNoRequired']}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_MOBILE)}
                    onChange={(value) => {
                      setFieldValue('beneMobileNo', value?.value)
                    }}
                    mode='onlyNumber'
                    name='beneMobileNo'
                    minLength={8}
                    maxLength={15}
                  />
                  <InputError text={errors.beneMobileNo} touched={touched.beneMobileNo} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='15'
                    showAsterisk={internationalBeneConfig['isTransferLimitRequired']}
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.TRANSFER_LIMIT)}
                    mode='amount'
                    onChange={(value) => {
                      setFieldValue('transferAmount', value.floatValue)
                      setFieldValue('maxTransferAmount', value?.value)
                    }}
                    name='transferAmount'
                  />
                  <InputError text={errors.maxTransferAmount} touched={touched.maxTransferAmount} />
                  <InputError
                    text={`${t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_LIMIT_TXT)} ${
                      config.MIN_TRANSFER_LIMIT
                    }.00`}
                    touched={values.transferAmount < config.MIN_TRANSFER_LIMIT}
                  />
                </div>
              </div>

              <div className='mt-3'>
                {loading ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='16'
                    type='submit'
                    mode='newDesign'
                    text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  tabIndex={'17'}
                  onClick={() => history.goBack()}>
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.CONFIRMINTERNATIONAL)}</h3>
        <div>
          <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NAME1)}</h6>
          <h6 className='value'>{formValues.benName}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NICK_NAME1)}
          </h6>
          <h6 className='value'>{formValues.nickName}</h6>
        </div>

        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.ACCOUNT_NUMBER1)}
          </h6>
          <h6 className='value'>{formValues.accountNumber}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_ADDRESS1)}
          </h6>
          <h6 className='value'>{formValues.beneAddress}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_COUNTRY1)}
          </h6>
          <h6 className='value'>{formValues.beneCountry}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.MODE_OF_TRANSFER1)}
          </h6>
          <h6 className='value'>{formValues.modeofTransfer}</h6>
        </div>
        <div>
          <h6 className='label'>
            {formValues.modeofTransfer === 'SWIFT / BIC' ? <label>SWIFT/BIC Code</label> : ''}
            {formValues.modeofTransfer === 'IFSC' ? <label>IFSC Code</label> : ''}
            {formValues.modeofTransfer === 'Routing' ? <label>Routing Number</label> : ''}
          </h6>
          <h6 className='value'>{formValues.code}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BANK_ADDRESS1)}
          </h6>
          <h6 className='value'>{formValues.bankAddress}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BANK_COUNTRY1)}
          </h6>
          <h6 className='value'>{formValues.bankCountry}</h6>
        </div>
        <div>
          <h6 className='label'>
            {' '}
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.TRANSFER_LIMIT1)}
          </h6>

          <h6 className='value'>
            <NumberFormat
              value={formValues.maxTransferAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BRANCH1)}
          </h6>
          <h6 className='value'>{formValues.bankBranch}</h6>
        </div>

        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_EMAIL1)}
          </h6>
          <h6 className='value'>{formValues.beneEMail}</h6>
        </div>

        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_MOBILE1)}
          </h6>
          <h6 className='value'>{formValues.beneMobileNo}</h6>
        </div>

        <div>
          <TermsAndCondition module='BENEFICIARY' />
        </div>

        <div className='mt-3'>
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              type='button'
              mode='newDesign'
              text={t(ADD_BENEFICIARY.CONFIRM)}
              onClick={() => (otpEnabled ? setStage(3) : onConfirm())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {' '}
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='BENE_INTERNATIONAL'>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
